var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiativeAnnual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00176 3.75C8.58691 3.75 8.25176 3.41484 8.25176 3C8.25176 2.58516 8.58691 2.25 9.00176 2.25H12.7518C13.1666 2.25 13.5018 2.58516 13.5018 3V6.75C13.5018 7.16484 13.1666 7.5 12.7518 7.5C12.3369 7.5 12.0018 7.16484 12.0018 6.75V4.81172L8.03145 8.77969C7.73848 9.07266 7.2627 9.07266 6.96973 8.77969L4.50176 6.31172L1.28145 9.52969C0.988477 9.82266 0.512695 9.82266 0.219727 9.52969C-0.0732422 9.23672 -0.0732422 8.76094 0.219727 8.46797L3.96973 4.71797C4.2627 4.425 4.73848 4.425 5.03145 4.71797L7.50176 7.18828L10.94 3.75H9.00176V3.75",
    fill: "#1A4252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiativeAnnual);
export default __webpack_public_path__ + "static/media/initiative-annual.6a728dfc69267c8a8b191dfbc5aac86c.svg";
export { ForwardRef as ReactComponent };